import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

import Card from "react-bootstrap/Card";

import { useEsus } from "@/hooks/useEsus";
import { getQuarterDates } from "@/utils/quarters";

import { IndicatorsEsfFilters } from "./IndicatorEsfFilters";
import { IndicatorEsfC1 } from "./IndicatorEsfC1";
import { IndicatorEsfC2 } from "./IndicatorEsfC2";
import { IndicatorEsfC3 } from "./IndicatorEsfC3";
import { IndicatorEsfC4 } from "./IndicatorEsfC4";
import { IndicatorEsfC5 } from "./IndicatorEsfC5";
import { IndicatorEsfC6 } from "./IndicatorEsfC6";
import { IndicatorEsfC7 } from "./IndicatorEsfC7";

export function IndicatorsEsf() {
	const { indicator } = useParams();
	const { healthTeams } = useEsus();
	const [selectedIne, setSelectedIne] = useState<string>();
	const [selectedIndicator, setSelectedIndicator] = useState<number>(
		indicator ? Number(indicator) : 1
	);
	const quarter = Math.ceil((dayjs().month() + 1) / 4);
	const now = dayjs();
	const currentYear = now.year();
	const currentMonth = now.month();
	const [selectedQuarter, setSelectedQuarter] = useState<string>(`Q${quarter}/${currentYear}`);
	const [selectedMonth, setSelectedMonth] = useState<string>(String(currentMonth + 1).padStart(2, "0"));
	const [isPendingToUpdate, setIsPendingToUpdate] = useState(true);
	const selectedYear = dayjs(getQuarterDates(selectedQuarter).startDate).year();
	const selectedMonthNumber = Number(selectedMonth);

	const indicatorProps = {
		selectedQuarter,
		selectedYear,
		selectedMonth: selectedMonthNumber,
		selectedIne,
		isPendingToUpdate,
		setIsPendingToUpdate,
	};
	function getSelectedIndicator() {
		switch (selectedIndicator) {
			case 1:
				return <IndicatorEsfC1 {...indicatorProps} />;
			case 2:
				return <IndicatorEsfC2 {...indicatorProps} />;
			case 3:
				return <IndicatorEsfC3 {...indicatorProps} />;
			case 4:
				return <IndicatorEsfC4 {...indicatorProps} />;
			case 5:
				return <IndicatorEsfC5 {...indicatorProps} />;
			case 6:
				return <IndicatorEsfC6 {...indicatorProps} />;
			case 7:
				return <IndicatorEsfC7 {...indicatorProps} />;
			default:
				return <></>;
		}
	}

	useEffect(() => {
		setIsPendingToUpdate(true);
	}, [selectedIndicator]);

	return (
		<>
			<Card className="m-3 p-2">
				<Card.Body>
					<IndicatorsEsfFilters
						selectedIndicator={selectedIndicator}
						setSelectedIndicator={setSelectedIndicator}
						selectedQuarter={selectedQuarter}
						setSelectedQuarter={setSelectedQuarter}
						selectedMonth={selectedMonth}
						setSelectedMonth={setSelectedMonth}
						selectedIne={selectedIne}
						setSelectedIne={setSelectedIne}
						healthTeams={healthTeams}
						handleFilter={() => setIsPendingToUpdate(true)}
					/>
				</Card.Body>
			</Card>
			{getSelectedIndicator()}
		</>
	);
}
